import type { ReactElement } from 'react';

import { createAction } from '@reduxjs/toolkit';

import type { Column } from '@models/ConversionTool/conversionToolColumnsGet/types';

import {
  CONVERSION_TOOL_COLUMNS_FETCH_FAILURE,
  CONVERSION_TOOL_COLUMNS_FETCH_START,
  CONVERSION_TOOL_COLUMNS_FETCH_SUCCESS,
  CONVERSION_TOOL_COLUMNS_RESET,
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START,
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_SUCCESS,
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_FAILURE,
  CONVERSION_TOOL_SET_MAPPING_COLUMNS,
} from './conversionToolColumns.const';

export const conversionToolColumnsResetAction = createAction(CONVERSION_TOOL_COLUMNS_RESET);

export const conversionToolColumnsFetchStart = createAction(CONVERSION_TOOL_COLUMNS_FETCH_START);
export const conversionToolColumnsFetchSuccess = createAction<Array<Column>>(
  CONVERSION_TOOL_COLUMNS_FETCH_SUCCESS
);
export const conversionToolColumnsFetchFailure = createAction<string | ReactElement>(
  CONVERSION_TOOL_COLUMNS_FETCH_FAILURE
);

export const conversionToolColumnsSetSelectedValuesStartAction = createAction(
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START
);
export const conversionToolColumnsSetSelectedValuesSuccessAction = createAction(
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_SUCCESS
);
export const conversionToolColumnsSetSelectedValuesFailureAction = createAction(
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_FAILURE
);
export const conversionToolColumnsSetMappingColumnsAction = createAction(
  CONVERSION_TOOL_SET_MAPPING_COLUMNS
);
